import React from 'react'
import '../../styles/Utils/Button.css'

{/*
<Button 
    theme={'light | dark | primary | danger'}
    icon={<FontAwesomeIcon icon={faComputerMouse} />}
    text={""}
    rounded={false}
    disabled={false}
    onClick={() => {}}
/>
--buttonDark: #89a58d;
--buttonDarkActive: #566b59;
--buttonDarkText: #ffffff;
--buttonLight: #ffffff;
--buttonLightActive: #ecf5ec;
--buttonLightText: #435e48;
*/}

function Button({ theme, icon, text, rounded, disabled, onClick }) {

    return (

        <div className='buttonContainer'>
            <div className={['button', rounded ? 'buttonRounded' : null, disabled ? 'buttonDisabled' : null, theme === 'dark' ? 'buttonDark' : theme === 'primary' ? 'buttonPrimary' : theme === 'danger' ? 'buttonDanger' : 'buttonLight'].join(" ")} onClick={() => onClick && !disabled ? onClick() : null}>
                <div className={['buttonIcon', theme === 'dark' ? 'buttonIconDark' : theme === 'primary' ? 'buttonIconPrimary' : theme === 'danger' ? 'buttonIconDanger' : 'buttonIconLight'].join(" ")}>
                    {icon}
                </div>
                <div className={['buttonText', theme === 'dark' ? 'buttonTextDark' : theme === 'primary' ? 'buttonTextPrimary' : theme === 'danger' ? 'buttonTextDanger' : 'buttonTextLight'].join(" ")}>{text}</div>
            </div>
        </div>

    )

}

export default Button